import React, { useState, useEffect } from 'react';
import { Box, Card, Typography, TextField, Button, Select, MenuItem, OutlinedInput, Chip } from '@mui/material';
import axios from 'axios';

const CompletaProfilo = () => {
  const [formData, setFormData] = useState({
    address: '',
    phone: '',
    birthPlace: '',
    linkedin: '',
    skills: [] // Salveremo gli ID delle categorie selezionate
  });
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState('');

  // Al caricamento del componente, scarica le categorie
  useEffect(() => {
    axios.get('/api/categories')
      .then(res => {
        setCategories(res.data);
      })
      .catch(err => {
        console.error("Errore nel caricare le categorie", err);
        setError('Impossibile caricare le categorie. Riprova più tardi.');
      });
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSkillChange = (event) => {
    const { target: { value } } = event;
    setFormData({
      ...formData,
      skills: typeof value === 'string' ? value.split(',') : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Qui, in futuro, invieremo i dati al backend per l'aggiornamento
    console.log("Dati da inviare:", formData);
    alert('Profilo completato! Verrai reindirizzato.');
    // window.location.href = '/'; // Esempio di redirect
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '80vh' }}>
      <Card sx={{ p: 4, maxWidth: 600, width: '100%' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Completa il Tuo Profilo
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          Per favore, inserisci i dati mancanti per completare la registrazione. Queste informazioni saranno visibili alle aziende e necessarie per l'approvazione del tuo account.
        </Typography>
        {error && <Typography color="error">{error}</Typography>}
        <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField name="address" label="Indirizzo di Residenza" onChange={handleChange} required />
          <TextField name="phone" label="Numero di Telefono" onChange={handleChange} required />
          <TextField name="birthPlace" label="Luogo di Nascita" onChange={handleChange} required />
          <TextField name="linkedin" label="URL Profilo LinkedIn (Opzionale)" onChange={handleChange} />

          <Typography sx={{ mt: 1, color: 'text.secondary' }}>Competenze</Typography>
          <Select
            multiple
            name="skills"
            value={formData.skills}
            onChange={handleSkillChange}
            input={<OutlinedInput label="Competenze" />}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => {
                  const category = categories.find(c => c.id === value);
                  return <Chip key={value} label={category?.name || ''} />;
                })}
              </Box>
            )}
          >
            {categories.map((category) => (
              <MenuItem key={category.id} value={category.id}>
                {category.name}
              </MenuItem>
            ))}
          </Select>

          <Button type="submit" variant="contained" size="large" sx={{ mt: 2 }}>
            Salva e Invia per Approvazione
          </Button>
        </Box>
      </Card>
    </Box>
  );
};

export default CompletaProfilo;